import React, {useState, useEffect} from 'react'
import Loading from '../general/Loading';
import StaffImg1 from '../assets/staff-img1.gif';


const ManagePres = () => {
  const [prescription, setPrescription] = useState([]);
  const [loading, setLoading] = useState(false);
const [modalImage, setModalImage] = useState(null);
  const [selectedPres, setSelectedPres] = useState('');
const [showUpdate, setShowUpdate] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [response, setResponse] = useState(null);


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    };

      useEffect(() => {
        const fetchPrescription = async () => {
          setLoading(true);
          try {
            const response = await fetch(`https://api.kcmstore.in/store/get-prescription`);
            setLoading(false);
            if (response.ok) {
              const data = await response.json();
              const sortedProducts = data.sort((a, b) => b.id - a.id);
              setPrescription(sortedProducts);
            } else {
              console.error('Failed to fetch prescription');
            }
          } catch (error) {
            setLoading(false);
            console.error('Error fetching prescription:', error);
          }
        };
    
        fetchPrescription();
      }, []);


      const handleShowUpdate = (pres) => {
        setSelectedPres(pres);
        setShowUpdate(true);
      }


        const handleUpdateStatus = async (presId, prodName, userId, status) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/update-prescription-status/${presId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          status: status,
          user_id: userId,
          prod_name: prodName
        }),
      });

      setLoading(false);
      if (response.ok) {
        const updatedOrder = await response.json();
        setPrescription(prevOrders =>
          prevOrders.map(order =>
            order.id === presId ? { ...order, status: status } : order
          )
        );
        setShowUpdate(false);
        setResponse('Prescription status Updated.');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      } else {
        setLoading(false);
        setResponse('Failed to update prescription status');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      setLoading(false);
      console.error('Error updating status:', error);
    }
  };

  return (
    <>
            <section className='py-4 bg-light'>
        <div className='px-3'>

          <div className='d-flex'>
            <p className='sec-heading'>Manage Prescription</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Approve</span>
          </div>

          <p className='fst-italic'>Prescriptions Added by Buyer for Medicines which require Medical Prescription of Doctor</p>

                    <div className="table-responsive bg-white rounded-4 mt-4">
                        <table className='w-100'>
                            <tr style={{ borderBottom: '2px solid var(--darkblue)' }}>
                                <th className='px-3 py-3'>Req On</th>
                                <th className='px-3 py-3'>Product Name</th>
                                <th className='px-3 py-3'>User Details</th>
                                <th className='px-3 py-3'>Attachment</th>
                                <th className='px-3 py-3'>Status</th>
                                <th className='px-3 py-3'>Activity</th>
                            </tr>


                            {prescription.length > 0 ? (
                                prescription.map((pres, index) => (
                                    <tr className='text-muted fw-semibold' style={{ backgroundColor: index % 2 === 0 ? 'var(--peach)' : 'white' }}>
                                        <td className='px-3 py-2'>{formatDate(pres.req_on) || 'NA'}</td>
                                        <td className='px-3 py-2'>{pres.prod_name || 'NA'}</td>
                                        <td className='px-3 py-2'>{pres.user_name || 'NA'} {pres.user_phone || 'NA'}</td>
<td className='px-3 py-2'>
  {pres.attachment ? (
    <img 
      src={`https://api.kcmstore.in/sUploads/${pres.attachment}`} 
      alt="Prescription" 
      className='rounded cursor-pointer'
      style={{height: '60px'}} 
onClick={() => setModalImage(`https://api.kcmstore.in/sUploads/${pres.attachment}`)}     />
  ) : 'NA'}
</td>
                                        <td className='px-3 py-2 text-success'>{pres.status || 'NA'}</td>
                                <th className='px-3 py-2'><span className='danger-btn cursor-pointer' onClick={() => handleShowUpdate(pres)}>Update</span></th>
                                    </tr>
                                ))
                            )

                                : (
                                    <>
                                        <tr className='text-center'>
                                            <td colSpan='5'>
                                                <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10 my-3' alt='Staff' />
                                                <p className='fw-bold'>No Prescription Requests yet.</p>
                                            </td>
                                        </tr>
                                    </>
                                )}
</table>
</div>

</div>
</section>

{modalImage && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center"
    style={{ zIndex: 1050 }}
    onClick={() => setModalImage(null)}
  >
    <img
      src={modalImage}
      alt="Full Prescription"
      className="img-fluid rounded shadow"
      style={{ maxHeight: '90%', maxWidth: '90%' }}
    />
  </div>
)}


      {showUpdate && (
        <>
          <section className='delete-dialog px-3' onClick={() => setShowUpdate(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Update Prescription Status</p>

              <select
                id="order-status"
                className="form-select mb-4"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}>
                <option value="">Select status</option>
                <option value="Approved">Approved</option>
                <option value="Unapproved">Unapproved</option>
                {/* <option value="Out for Delivery">Out for Delivery</option> */}
              </select>

              <button className='success-btn' onClick={() => handleUpdateStatus(selectedPres.id, selectedPres.prod_name, selectedPres.user_id, newStatus)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowUpdate(false)}>No</button>
            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}
    </>
  )
}

export default ManagePres
